/**
 * Cache de estado storefront por sucursal: perfil público, zonas de delivery y
 * estado de integración MP. Capa pura — NO importa los repos (los repos la
 * importan a ella para invalidar tras escrituras, sin ciclo de dependencias).
 *
 * Contrato:
 * - Lecturas: pasan por `settings/application/storefrontStatus.ts`.
 * - Escrituras: todo write path sobre public_store_profiles / delivery_zones /
 *   config MP debe invalidar (o write-through) la entrada de la branch.
 * - Read-modify-write (ej. setStoreManualOverride) lee SIEMPRE fresco.
 * - Logout / cambio de org: `clearStorefrontStatusCaches` corre vía
 *   registerSessionCacheClearHandler (sessionResetRegistration.ts).
 */
import { createKeyedTtlCache } from '../../shared/data/keyedTtlCache';
import { runStorefrontReadModelInvalidators } from '../../shared/ports/readModelInvalidationPort';

const TTL_MS = 5 * 60_000;

export const storefrontProfileCache = createKeyedTtlCache(TTL_MS);
export const storefrontZonesCache = createKeyedTtlCache(TTL_MS);
export const storefrontMpStatusCache = createKeyedTtlCache(TTL_MS);

/** Invalida las 3 fuentes de una branch (tras writes que tocan profile o MP). */
export function invalidateStorefrontStatus(branchId: string): void {
  storefrontProfileCache.invalidate(branchId);
  storefrontZonesCache.invalidate(branchId);
  storefrontMpStatusCache.invalidate(branchId);
  // Read models consolidados (home_snapshot, store_activation_snapshot).
  runStorefrontReadModelInvalidators(branchId, 'profile');
}

export function invalidateStorefrontZones(branchId?: string): void {
  // update/delete por zoneId no conocen la branch — blast radius acotado.
  if (branchId) storefrontZonesCache.invalidate(branchId);
  else storefrontZonesCache.clear();
  runStorefrontReadModelInvalidators(branchId ?? null, 'zones');
}

export function invalidateStorefrontMpStatus(branchId: string): void {
  storefrontMpStatusCache.invalidate(branchId);
  runStorefrontReadModelInvalidators(branchId, 'mp');
}

export function clearStorefrontStatusCaches(): void {
  storefrontProfileCache.clear();
  storefrontZonesCache.clear();
  storefrontMpStatusCache.clear();
}
